// 다크 모드 라이트 모드 전환.

export const lightTheme = {
  body: "#fcf6f4",
  text: "#000000",
  fontFmaily: "'Source Sans Pro', sans-serif",
  bodyRgba: "252,246,244,0.8",
  textRgba: "0,0,0,0.8",
};

export const darkTheme = {
  body: "#000000",
  text: "#fcf6f4",
  fontFmaily: "'Source Sans Pro', sans-serif",
  bodyRgba: "0,0,0,0.8",
  textRgba: "252,246,244,0.8",
};
